// routes/AppRoutes.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/auth/ProtectedRoute';
import { USER_ROLES } from './utils/constants';

// Public Pages
import HomePage from './pages/public/HomePage';
import ContestsPage from './pages/public/ContestsPage';
import ContestDetailPage from './pages/public/ContestDetailPage';
import PaymentVerifyPage from './pages/public/PaymentVerifyPage';

import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import VerifyResetOtpPage from './pages/auth/VerifyResetOtpPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';

// Auth Pages
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import ProfilePage from './pages/auth/ProfilePage';
import PendingApprovalPage from './pages/auth/PendingApprovalPage';
import UnauthorizedPage from './pages/auth/UnauthorizedPage';

// Admin Pages
import DashboardPage from './pages/admin/DashboardPage';
import MyHostsPage from './pages/admin/MyHostsPage';
import MyContestsPage from './pages/admin/MyContestsPage';
import ContestDetailsPage from './pages/admin/ContestDetailsPage';
import CategoryContestantsPage from './pages/admin/CategoryContestantsPage'; // ADD THIS IMPORT
import VotesPage from './pages/admin/VotesPage';
import PaymentsPage from './pages/admin/PaymentsPage';
import StatisticsPage from './pages/admin/StatisticsPage';
import UsersPage from './pages/admin/UsersPage';
import PermissionsPage from './pages/admin/PermissionsPage';
import ElectionsPage from './pages/public/elections/ElectionsPage';
import ElectionVotingPage from './pages/public/elections/ElectionVotingPage';
import ElectionAdminLogin from './pages/admin/elections/ElectionAdminLogin';
import ElectionDashboard from './pages/admin/elections/ElectionDashboard';
import ManageSchoolsPage from './pages/admin/elections/ManageSchoolsPage';
import ManageAdminsPage from './pages/admin/elections/ManageAdminsPage';
import ManageElectionsPage from './pages/admin/elections/ManageElectionsPage';
import ManageElectionDetailsPage from './pages/admin/elections/ManageElectionDetailsPage';
import ElectionResultsAdminPage from './pages/admin/elections/ElectionResultsAdminPage';
import ElectionAdminRegister from './pages/admin/elections/ElectionAdminRegister';
import SnapshotsPage from './pages/admin/SnapshotsPage';
// import ElectionVotingPage from './pages/public/ElectionVotingPage';

// import ElectionsPage from './pages/public/ElectionsPage';

const AppRoutes = () => {

  console.log("User Role", USER_ROLES)

  console.log('Rendering AppRoutes');
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/contests" element={<ContestsPage />} />
      <Route path="/contests/:contestId" element={<ContestDetailPage />} />
      <Route path="/payment/verify" element={<PaymentVerifyPage />} />

      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
<Route path="/verify-reset-otp" element={<VerifyResetOtpPage />} />
<Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* Auth Routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/pending-approval" element={<PendingApprovalPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      {/* Protected Routes - Require Authentication */}
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/permissions"
        element={
          <ProtectedRoute requiredRoles={[USER_ROLES.COMPANY_ADMIN, USER_ROLES.SUPER_ADMIN]}>
            <PermissionsPage />
          </ProtectedRoute>
        }
      />

      {/* SUPER_ADMIN ONLY - Dashboard */}
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute requiredRoles={[USER_ROLES.SUPER_ADMIN]}>
            <DashboardPage />
          </ProtectedRoute>
        }
      />

      {/* SUPER_ADMIN ONLY - Users Management */}
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute requiredRoles={[USER_ROLES.SUPER_ADMIN]}>
            <UsersPage />
          </ProtectedRoute>
        }
      />

      {/* ADMIN & SUPER_ADMIN - Can manage hosts and contests */}
      <Route
        path="/admin/hosts"
        element={
          <ProtectedRoute requiredRoles={[USER_ROLES.COMPANY_ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.SUB_ADMIN]}>
            <MyHostsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/contests"
        element={
          <ProtectedRoute requiredRoles={[USER_ROLES.COMPANY_ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.SUB_ADMIN]}>
            <MyContestsPage />
          </ProtectedRoute>
        }
      />

      {/* Election Routes */}
      <Route path="/elections" element={<ElectionsPage />} />
      <Route path="/elections/:schoolId/vote" element={<ElectionVotingPage />} />
      <Route path="/admin/election-login" element={<ElectionAdminLogin />} />
      <Route path="/admin/election-register" element={<ElectionAdminRegister />} />
      <Route path="/admin/election-dashboard" element={<ElectionDashboard />} />
      <Route path="/admin/manage-schools" element={<ManageSchoolsPage />} />
      <Route path="/admin/manage-admins" element={<ManageAdminsPage />} />
      <Route path="/admin/manage-elections" element={<ManageElectionsPage />} />
      <Route path="/admin/elections/:electionId/manage" element={<ManageElectionDetailsPage />} />
      <Route path="/admin/elections/:electionId/results" element={<ElectionResultsAdminPage />} />

      <Route
        path="/admin/contests/:contestId"
        element={
          <ProtectedRoute requiredRoles={[USER_ROLES.COMPANY_ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.SUB_ADMIN]}>
            <ContestDetailsPage />
          </ProtectedRoute>
        }
      />
      {/* ADD THIS NEW ROUTE - Category Contestants Page */}
      <Route
        path="/admin/contests/:contestId/categories/:categoryId"
        element={
          <ProtectedRoute requiredRoles={[USER_ROLES.COMPANY_ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.SUB_ADMIN]}>
            <CategoryContestantsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/votes"
        element={
          <ProtectedRoute requiredRoles={[USER_ROLES.COMPANY_ADMIN, USER_ROLES.SUPER_ADMIN]}>
            <VotesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/payments"
        element={
          <ProtectedRoute requiredRoles={[USER_ROLES.COMPANY_ADMIN, USER_ROLES.SUPER_ADMIN]}>
            <PaymentsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/statistics"
        element={
          <ProtectedRoute requiredRoles={[USER_ROLES.COMPANY_ADMIN, USER_ROLES.SUPER_ADMIN]}>
            <StatisticsPage />
          </ProtectedRoute>
        }
      />

      <Route path="/admin/snapshots" element={
  <ProtectedRoute requiredRoles={[USER_ROLES.SUPER_ADMIN]}>
    <SnapshotsPage />
  </ProtectedRoute>
} />

      {/* Fallback Route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;